import { get } from '@classic/Foundation/Services/ApiService'
import type { Ticket } from '@core/Areas/AccountActivity/types'

const enum LocalConstants {
  apiBase = '/$_/accountActivity/tickets',
}

export const getPendingTicketsForRaceFromApi = (raceKey: string) =>
  get<Response>({ url: `${LocalConstants.apiBase}/pending/race-card?raceSeq=${raceKey}` })

// Types

type Response = {
  tickets: Ticket[]
  totalTicketsCount: number
}
